// extracted by mini-css-extract-plugin
export var closeButton = "_ka-1";
export var closeX = "_ka-3";
export var container = "_ka-0";
export var image = "_ka-2";